import React, { useState, useEffect, useCallback } from 'react'
import { Pagination, Row, Col, Collapse, Button, Modal, message } from 'antd'
import axios from 'axios'
import PageHeader from '../Layout/PageHeader'
import AdminAuditLogsFilters from './AdminAuditLogsFilters'
import { CaretRightOutlined, DownloadOutlined } from '@ant-design/icons'
import AdminAuditLogItem from './AdminAuditLogItem';

const AdminAuditLogs = () => {
    const [pagination, setPagination] = useState({
        currentPage: 1,
        limit: 10,
    });
    const [adminAuditLogs, setAdminAuditLogs] = useState([])
    const [filters, setFilters] = useState({
        email: null,
        username: null,
        description: null,
        startDate: null,
        endDate: null
    })
    const [isLoading, setIsLoading] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false);

    const fetchAdminAuditLog = useCallback(async () => {
        setIsLoading(true)

        console.log("filters", filters);
        const params = {
            ...(filters.email !== null && { email: filters.email }),
            ...(filters.username !== null && { username: filters.username }),
            ...(filters.description !== null && { description: filters.description }),
            ...(filters.startDate && {
                startDate: filters.startDate?.startOf("day")?.toISOString(),
            }),
            ...(filters.endDate && {
                endDate: filters.endDate?.endOf("day")?.toISOString(),
            }),
            limit: pagination.limit,
            page: pagination.currentPage
        }

        const res = await axios.get("api/admin-audit-logs", { params })

        setAdminAuditLogs(res.data.data)
        setPagination(prev => ({
            ...prev,
            totalSize: res.data.pagination?.totalSize
        }))
        setIsLoading(false)
    }, [pagination.currentPage, pagination.limit, filters])

    const downloadCSV = async () => {
        setIsDownloading(true);

        const messageContent = (
            <p>
                Are you sure you want to download {pagination?.totalSize} User logs data ?<br />
            </p>
        );

        const params = {
            ...(filters.email !== null && { email: filters.email }),
            ...(filters.username !== null && { username: filters.username }),
            ...(filters.description !== null && { description: filters.description }),
            ...(filters.startDate && {
                startDate: filters.startDate?.startOf("day")?.toISOString(),
            }),
            ...(filters.endDate && {
                endDate: filters.endDate?.endOf("day")?.toISOString(),
            }),
            limit: pagination.limit,
            page: pagination.currentPage
        };

        Modal.confirm({
            content: messageContent,
            title: `Download Admin Audit Log List ? `,
            async onOk() {
                await axios
                    .get("api/admin-audit-logs/csv", { params })
                    .then((res) => {
                        message.info(`Please check the Export progress in System -> Jobs`);
                    })
                    .catch((error) => {
                        message.error(error.message);
                    });
            },
        });

        setIsDownloading(false);
    };

    useEffect(() => {
        fetchAdminAuditLog()
    }, [pagination.currentPage, pagination.limit, filters])

    return (
        <div>
            <PageHeader
                title="Admin Audit Logs"
                childRoutes={[{ path: "/admin-audit-logs", breadcrumbName: "AdminAuditLogs" }]}
            />

            <Collapse expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}>
                <Collapse.Panel header="Filters" key="filters">
                    <AdminAuditLogsFilters
                        filters={filters}
                        onFiltersChange={filters => setFilters(filters)}
                    />
                </Collapse.Panel>
            </Collapse>

            <Row justify="end">
                <Col>
                    <Pagination
                        total={pagination?.totalSize}
                        onChange={(currentPage, limit) => {
                            setPagination({ ...pagination, limit, currentPage })
                        }}
                    />
                </Col>
            </Row>

            <Button onClick={downloadCSV} loading={isDownloading}>
                CSV <DownloadOutlined />
            </Button>

            <AdminAuditLogItem loading={isLoading} auditLog={adminAuditLogs} />

            <Row justify="end">
                <Col>
                    <Pagination
                        total={pagination?.totalSize}
                        onChange={(currentPage, limit) => {
                            setPagination({ ...pagination, limit, currentPage })
                        }}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default AdminAuditLogs